<article *ngIf="directoryItem$ | async as directoryItem"
         [attr.aria-labelledby]="directoryItem.id"
         [ngClass]="{'pcg-search-result-item--has-dates': directoryItem.nearestOccurrence}"
         class="pcg-search-result-item pcg-contrast__border-main">

    <div *ngIf="(directoryItem.isDefaultImage ? !!defaultImageUrl : !!directoryItem.posterImageUrl)"
         [ngClass]="{'pcg-search-result-item__img-col': !isImageLoading}">
        <img (load)="imageLoaded()"
             [src]="directoryItem.isDefaultImage ? defaultImageUrl : directoryItem.posterImageUrl"
             alt="">
    </div>

    <h3 [id]="directoryItem.id" class="pcg-search-result-item__title">
        <a [href]="getDetailsPageUrl()" class="pcg-search-result-item__title-link pcg-contrast__link">
            {{ directoryItem.name }}
        </a>
    </h3>

    <a [attr.aria-describedby]="directoryItem.id" [attr.data-id]="directoryItem.id"
       [attr.data-title]="directoryItem.name"
       [attr.data-url]="getDetailsPageUrl()"
       class="pcg-search-result-item__btn pcg-fav-button pcg-contrast__btn js-s4s-ng-booklet-button"
       href="javascript:void(0);">
        Add to My Booklet
    </a>

    <div *ngIf="directoryItem.nearestOccurrence" class="pcg-dates pcg-search-result-item__dates">
        <div class="pcg-dates__wrapper">
            <p class="pcg-dates__date pcg-contrast__color-main">{{ formatOccurrence(directoryItem.nearestOccurrence, directoryItem.startTime, directoryItem.endTime) }}</p>
            <button (click)="toggleUpcomingOccurrences()"
                    [attr.aria-controls]="'collapsible-dates-block-content-' + directoryItem.id"
                    [attr.data-bs-target]="'#collapsible-dates-block-content-' + directoryItem.id"
                    [id]="'collapsible-dates-block-' + directoryItem.id"
                    aria-expanded="false"
                    class="pcg-dates__button pcg-contrast__link"
                    data-bs-toggle="collapse"
                    type="button">
                {{ this.isUpcomingOccurrencesOpen ? "Hide" : "See more" }} dates
            </button>
        </div>
        <div [attr.aria-labelledby]="'collapsible-dates-block-'+directoryItem.id" [id]="'collapsible-dates-block-content-' + directoryItem.id" class="collapse">
            <ul *ngFor="let occurrence of getUpcomingOccurrences(directoryItem)" class="pcg-dates__list">
                <li class="pcg-contrast__color-main">{{ formatOccurrence(occurrence, directoryItem.startTime, directoryItem.endTime) }}</li>
            </ul>
        </div>
    </div>

    <p [innerHtml]="directoryItem.description"
       class="pcg-search-result-item__desc pcg-contrast__color-main"></p>

    <ul class="pcg-result-contacts">
        <li *ngIf="!!directoryItem.email && directoryItem.email.trim().toLowerCase() !== 'no@email.com'"
            class="pcg-result-contacts__item pcg-result-contacts__item--email pcg-contrast__color-main">
            <a class="pcg-result-contacts__link pcg-contrast__link" href="mailto:{{directoryItem.email}}">
                {{ directoryItem.email }}
            </a>
        </li>
        <li *ngIf="!!directoryItem.website && !!directoryItem.shortWebsiteAddress"
            class="pcg-result-contacts__item pcg-result-contacts__item--site pcg-contrast__color-main">
            <a class="pcg-result-contacts__link pcg-contrast__link" href="{{directoryItem.website}}" target="_blank" rel="noopener noreferrer">
                {{ directoryItem.shortWebsiteAddress }}
            </a>
        </li>
        <li *ngFor="let phone of directoryItem.phoneNumbers"
            class="pcg-result-contacts__item pcg-result-contacts__item--phone pcg-contrast__color-main">
            <a class="pcg-result-contacts__link pcg-contrast__link" href="tel:{{phone.number}}">
                {{ phone.label }}
            </a>
        </li>
    </ul>
</article>
